<template>
    <div class="fluid-container">
        <div class="row no-gutters">
            <div class="col-md-6 comfy-bg-azul-claro">
                <div class="row justify-content-center home-banner-call">
                    <h2 class="ivy-thin comfy-text px-5">Reserva un masaje <span class="ivy-bold-italic comfy-text-contrast">&nbsp;a domicilio&nbsp;</span> en minutos</h2>
                    <div class="col-10 col-md-6 comfy text-center my-5 r-15">
                        <h3 class="text-white fw-500 pt-3 ivy-bold" :style="boxtitle">¡Hola{{ cliente.nombre ? ' ' + cliente.nombre : '' }}!</h3>
                        <h5 class="text-white fw-400" :style="boxdescription">Selecciona ciudad para reservar</h5>
                        <el-row class="py-3">
                            <el-col :span="1">
                                &nbsp;
                            </el-col>
                            <el-col :span="10">
                                <el-select class="w-100" v-model="ciudad" clearable placeholder="Ciudad:" size="large">
                                    <el-option
                                        v-for="item in cities"
                                        :key="item.id"
                                        :label="item.microciudad"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="2">
                                &nbsp;
                            </el-col>
                            <el-col :span="10">
                                <el-button type="primary btn btn-block btn-sm" @click="irReserva">
                                    Reserva acá
                                </el-button>
                            </el-col>
                            <el-col :span="1">
                                &nbsp;
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
            <div class="col-md-6 home-top-img">
                <img :src="front_slides" />
            </div>
        </div>
    </div>
</template>

<style>
    .el-carousel img {
        border-radius: 10px;
    }
    .el-carousel__item img {
        object-fit: cover;
        height: 100%;
    }
    h3.el-carousel-title {
        color: #ffffff;
        font-size: 26px;
        position: absolute;
        font-weight: 600;
    }
    p.el-carousel-description {
        color: #ffffff;
        font-size: 22px;
        position: absolute;
        font-weight: 400;
    }
    .card-reserva-home {
        top: -20px;
        z-index: 999;
    }
    .el-button--primary {
        color: #18333d;
        background-color: #e0d6af;
        border-color: #e0d6af;
        font-size: 17px;
    }
    .el-button--primary:focus, .el-button--primary:hover {
        background: #c9d1c7;
        border-color: #c9d1c7;
        color: #18333d;
    }
</style>

<script>
    export default {
        props: [
            'cliente'
        ],
        data() {
            return {
                sliders: [],
                height: '',
                cities: [],
                ciudad: '',
                responsive: false,
                boxdescription: 'font-size: 22px',
                boxtitle: 'font-size: 28px',
                front_slides: this.setSlide()
            }
        },
        computed: {

        },
        watch: {

        },
        methods: {
            initWidth(){
                let width = window.innerWidth
                if(width > 1199){
                    this.height = '540px'
                    this.h3title = 'top: 90px; left:150px; width: 530px; font-size:28px'
                    this.pdescription = 'top: 140px; left:150px; width: 530px; font-size:24px'
                    this.boxtitle = 'font-size: 28px'
                    this.boxdescription = 'font-size: 22px'
                    return
                }
                if(width > 991){
                    this.height = '440px'
                    this.h3title = 'top: 90px; left:150px; width: 530px; font-size:28px'
                    this.pdescription = 'top: 140px; left:150px; width: 530px; font-size:24px'
                    this.boxtitle = 'font-size: 24px'
                    this.boxdescription = 'font-size: 18px'
                    return
                }
                if(width > 768){
                    this.height = '400px'
                    this.h3title = 'top: 50px; left:20px; width: 280px; font-size:18px'
                    this.pdescription = 'top: 80px; left:20px; width: 280px; font-size:14px'
                    this.boxtitle = 'font-size: 20px'
                    this.boxdescription = 'font-size: 14px'
                    return
                }if(width > 300){
                    this.height = '380px'
                    this.h3title = 'top: 60px; left:30px; width: 340px; font-size:22px'
                    this.pdescription = 'top: 100px; left:30px; width: 340px; font-size:18px'
                    this.boxtitle = 'font-size: 18px'
                    this.boxdescription = 'font-size: 12px'
                    this.responsive = true
                    return
                }
            },
            getSliders(){
                var url = '/get-sliders'
                axios.get(url).then(response => {
                    // console.log(response.data.sliders)
                    this.sliders = response.data.sliders
                }).catch(error => {
                    console.log(error)
                })
            },
            getCities(){
                var url = '/get-cities'
                axios.post(url).then(response => {
                    this.cities = response.data.cities
                })
            },
            irReserva(){
                window.location = '/reservar?ciudad=' + this.ciudad;
            },
            setSlide(){
                var max = 4;
                var min = 1;
                var random = Math.floor(Math.random() * (max - min + 1) + min);
                return `/frontend/img/promos/v3/front_slide_0${random}.webp`;
            }
        },
        mounted() {
            // console.log('--- sliders component mounted ---')
            this.getSliders()
            this.initWidth()
            this.getCities()
        }
    }
</script>
